<template>
  <div class="login">
    <!-- TODO: create generic styles and remove login class -->
    <div class='login-form'>
      <div class="header">
        <img alt="BCR logo" src="@/assets/images/logo.png">
      </div>
      <forgot-password-form/>
    </div>
  </div>
</template>
<script>
import ForgotPasswordForm from '@/components/ForgotPasswordForm.vue'
import axios from 'axios'

axios.defaults.headers.common['referer-id'] = new Date().toLocaleString().replace(/[^\d]/g, '') + parseInt(Math.random() * 100000)

export default {
  name: 'forgot_password',
  components: {
    ForgotPasswordForm
  }
}
</script>
